// Querys and Mutations
import {
    ALL_ACTIVE,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    CHANGE_STATUS,
    DELETE
} from '@/graphql/config/AreaGraphql'

// models
import { Paginator, ResponseDefault } from '@/models'
import { AreaModel, AreaForm, AreasWithPagination } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class AreaService {
    /**
     * Queries
     */

    async getAllActivate (): Promise<AreaModel[]> {
        return this.getActivated()
    }

    async getActivated (): Promise<AreaModel[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE
        })
        return result.data.areasActive
    }

    async getWithPagination (perPage = 10, page = 1): Promise<AreasWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })
        const pagination: Paginator = result.data.areasWithPagination.paginatorInfo
        const data: [AreaModel] = result.data.areasWithPagination.data
        const response: AreasWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    /**
     * Mutations
     */
    async create (form: AreaForm): Promise<AreaModel> {
        const result = await apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        })
        return result.data.createArea
    }

    async update (id: number, form: AreaForm): Promise<AreaModel> {
        const result = await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return result.data.updateArea
    }

    async changeStatus (id: number, status: boolean): Promise<AreaModel> {
        const result = await apolloClient.mutate({
            mutation: CHANGE_STATUS,
            variables: {
                id: id,
                input: {
                    is_active: status
                }
            }
        })
        return result.data.updateArea
    }

    async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
    }
}

export default new AreaService()
